import { getFormattedDate, maskMobileNumber, maskPhoneNumber, maskText } from '@/utils/format';
import translate from '@/components/textData/utils';

export const formatters = {
  cardCode: (value: string) => maskText(value, '9999 '.repeat(20)),
  cep: (value: string) => maskText(value, '99999-999'),
  cpf: (value: string) => maskText(value, '999.999.999-99'),
  cnpj: (value: string) => maskText(value, '99.999.999/9999-99'),
  date: (value: string) => getFormattedDate(value),
  dateWithoutTZ: (value: string) => getFormattedDate(value, { discardTimezone: true }),
  dateTime: (value: string) => getFormattedDate(value, { showHours: true }),
  marital: (value: string) => translate.marital(value),
  mobileNumber: (value: string) => maskMobileNumber(value),
  phoneNumber: (value: string) => maskPhoneNumber(value),
  relationship: (value: string) => translate.relationship(value),
  boolean: (value: string) => translate.boolean(value),
  rg: (value: string) => maskText(value, '99.999.999-9'),
  sex: (value: string) => translate.sex(value),
  text: (value: string) => value,
  month: (value: string) => translate.month(value),
};

export type FormatData = keyof typeof formatters;

const formatText = (value: any, key: FormatData, textDefault = 'Não encontrado'): string => {
  if (!value && !['boolean', 'number'].includes(typeof value)) {
    return '';
  }

  const formatter = formatters[key];
  const formatted = formatter ? formatter(value) : undefined;
  return (formatted as string) || textDefault;
};

export default formatText;
